// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { DataCache } from './DataCache';
function loop(callback, interval = 500) {
    callback();
    setTimeout(() => {
        loop(callback, interval);
    }, interval);
}
export function startRecalculateBalancesLoop() {
    loop(() => DataCache.RecalculateBalances(), 500);
}
